import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { prefetchPianoSamples } from "./audio/piano";

// Nearly every lesson page plays the piano; have the samples cached before the
// first click instead of making that click wait for them.
prefetchPianoSamples();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
